<template>
  <div class="role">
    <div class="card-container">
      <div class="card-title">
      </div>
      <div class="card-content">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="监管小区"
              >
                <a-select
                  v-decorator="[
                    'community',
                  ]"

                  show-search
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="changeArea"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.housingEstate"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="监管点位"
              >
                <a-select
                  v-decorator="[
                    'communis',
                  ]"
                  allow-clear
                >
                  <a-select-option
                    v-for="(item, index) in lists"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                label="手机号"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
              >
                <a-input v-decorator="['inValue']" class="w100" />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" html-type="submit">
                  查询
                </a-button>
                <a-button @click="resetForm">
                  重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            运营人员考勤信息
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :row-key="record => record.id"
          @change="handleTableChange"
        >
          <template slot="userType" slot-scope="record">
            <span>{{ record|titleFilter }}</span>
          </template>
          <template slot="operate" slot-scope="record">
            <a-button

              class="table-btn-link"
              type="link"
              size="small"
              @click="linkDetail(record)"
            >
              查看详情
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getCreditCardInfoList } from '@/api/member'
import { getPhotoList, getEstateZyProduct } from '@/api/system'
import {
  getArea,
  getEstate

} from '@/components/mixins/mixins.js'
const columns = [
  {
    title: '人员角色',
    dataIndex: 'userType',
    key: 'userType',
    scopedSlots: { customRender: 'userType' }
  },
  {
    title: '人员姓名',
    dataIndex: 'realName'
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '门禁卡号',
    dataIndex: 'cardNo'
  },
  {
    title: '区域',
    dataIndex: 'productAStreetName'
  },
  {
    title: '小区',
    dataIndex: 'productEstateName'

  },
  {
    title: '点位名称',
    dataIndex: 'productName'

  },
  {
    title: '投递时间',
    dataIndex: 'creditCardTime'

  },

  {
    title: '操作',
    dataIndex: '',
    key: 'operate',
    width: '140px',
    fixed: 'right',
    scopedSlots: { customRender: 'operate' }
  }
]

export default {
  filters: {
    titleFilter: function (value) {
      switch (value) {
        case '0':
          return '超级管理员'
        case '1':
          return '区域管理员'
        case '2':
          return '操作员'
        case '3':
          return '商户'
        case '5':
          return '政府'
        case '6':
          return '督导'
        case '7':
          return '运营人员'
        case '8':
          return '物业'
        case '9':
          return '政府'
        case '10':
          return '售后'
        case '11':
          return '清算'
        case '12':
          return '网格人员'
        default:
          return '字段值异常，请检查后台数据'
      }
    }
  },
  mixins: [getArea, getEstate],
  data () {
    return {

      spinInOut: false,

      region: [],

      loading: false,

      columns,
      formData: [],

      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },

      inside: {},
      imgId: '',

      selectedRowKeys: [],
      lists: [],
      communis: ''
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, {})
  },
  created: function () {

  },
  mounted () {
    this.getRoleList()
    this.getEstate()
    this.getArea('', 2)
    console.log(this.$store.state, '555')
  },

  methods: {
    ...mapGetters(['avatar', 'userInfo']),
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onChange (e) {
      this.spinInOut = true
      this.inside = {}
      const pamar = {
        id: this.imgId,
        type: e.target.value === 'b' ? 2 : 1
      }
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.inside = res.result[0]
          setTimeout(() => {
            this.spinInOut = false
          }, 1000)
        } else {
          this.spinInOut = false
        }
      })
    },

    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    getRoleList () {
      const params = {
        userType: 7,
        productId: this.form.getFieldValue('communis') || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        estateName: this.form.getFieldValue('community') || '',
        mobile: this.form.getFieldValue('inValue') || ''
      }

      this.loading = true
      getCreditCardInfoList(params).then(res => {
        this.loading = false
        const result = res.result
        this.formData = result.list
        this.pagination.total = result.totalCount
      })
    },
    resetForm () {
      this.region = []
      this.form.resetFields()
      this.getEstate()
      this.getRoleList()
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getRoleList()
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.pagination.current = 1
          this.getRoleList()
        }
      })
    },

    changeArea (val) {
      this.getEstateZyProduct(val)
    },
    // 点位搜索
    getEstateZyProduct (name) {
      const params = {
        estateName: name
      }
      getEstateZyProduct(params).then((res) => {
        this.lists = res.result
      })
    },
    linkDetail (item) {
      this.$router.push({ path: '/administrator/administrators', query: { id: item.id, name: item.productAStreetName }})
    }

  }
}
</script>

<style scoped>
.eject_con {
  text-align: center !important;
}
 /deep/ .ant-drawer-body {
    padding:24px 38px !important;
    margin: 0;
}
.viewer_cen {
width: 100%;
margin-left: 8px;
  position: absolute;
  background-color:rgba(0,0,0,0.35);
      /* background: #000000; */
      color: #fff;
    /* border-radius: 0px 0px 8px 8px; */
    /* opacity: 0.35; */
    top: 24px;
    left: -8px;
    text-align: center;
    /* left: 18px; */
    /* padding: 4px 7px; */
    padding: 4px 0;
}
.viewer_bom {
 position: absolute;
 color: #fff;
 top: 14px;
    left: 33px;
}
>>> .ant-form-item-label{
  text-align: left;
}
</style>
<style lang="stylus">
.ysOpenDevice
  margin-bottom 18px
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none
</style>
<style lang="stylus" scoped>
.eject_content
  .pic
    .pic_top
      display flex
      justify-content: space-between;
      margin-bottom: 15px;
      margin-top: 20px;
      span:nth-child(1)
        width: 5px;
        height: 16px;
        background: #1890ff;
        margin-right: 10px;
    .pic_bot
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      .img_list
        margin 10px 8px
        position: relative;
        img
          width 130px
          height 100px
          border-radius 4%
.modalimg
  text-align center
.qualified
  background: linear-gradient(315deg, transparent 50%, rgba(38, 181, 71, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.noqualified
  background: linear-gradient(315deg, transparent 50%, rgba(215, 45, 32, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.spanText
  position absolute
  top 7px
  transform rotate(-45deg)
  font-size 12px
  font-weight 400
</style>
